import {
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  InputGroup,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import CategoriasCode from "./Categorias.Code";
import { useEffect, useState } from "react";
import { IRoute } from "src/interfaces/IRoute";
import { useNavigate } from "react-router-dom";

const CategoriasView = () => {
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const navigate = useNavigate();
  const { register, errors, handleSubmit, onSubmit, loading, data } =
    CategoriasCode();

  useEffect(() => {
    setMenuItens([
      {
        name: "Nova Categoria...",
        route: "/estoque/produtos/categorias/cadastro",
      },
    ]);
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar = (id: number) => () => {
    navigate(`/estoque/produtos/categorias/cadastro?id=${id}`);
  };

  return (
    <Container>
      <HeadPage headText="Categorias">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.name}
              onClick={handleClickNavigate(item.route)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
      </HeadPage>
      <Row>
        <Col>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <InputGroup hasValidation>
              <FloatingLabel controlId="pesquisar" label="Pesquisar">
                <Form.Control
                  type="text"
                  placeholder="Pesquisar"
                  isInvalid={!!errors.nome?.message?.toString()}
                  {...register("nome")}
                />
                {errors.nome?.message?.toString() && (
                  <Form.Control.Feedback type="invalid">
                    {errors.nome?.message?.toString()}
                  </Form.Control.Feedback>
                )}
              </FloatingLabel>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        {!loading ? (
          <>
            <Col>
              {data && data.length > 0 ? (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th className="col-12">Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item) => (
                      <tr
                        key={item.id}
                        onClick={handleClickAlterar(item.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="col-12">{item.nome}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <Form.Text>Sem Dados</Form.Text>
              )}
            </Col>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Row>
    </Container>
  );
};
export default CategoriasView;
